import { connect } from "react-redux";
import EquipmentDetail from "./equipment-detail";
import { getEquipmentById } from "../utils";

const mapStateToProps = (state) => ({
	equipment: getEquipmentById(state),
});

export default connect(mapStateToProps)(EquipmentDetail);
